// extracted by mini-css-extract-plugin
export default {"check":"styles_check__Lkszv","right":"styles_right__X5w3l","left":"styles_left__FMERk","mark":"styles_mark__iw2Bu","dark":"styles_dark__FXrWi"};